export const CONTRACTOR_PORTAL_BASE = "/SLN/Contractor";

/** Primary navigation — under unified /SLN/Contractor area. */
export const CONTRACTOR_PORTAL_NAV_ITEMS = [
  {
    id: "dashboard",
    label: "Dashboard",
    labelFa: "داشبورد",
    path: CONTRACTOR_PORTAL_BASE,
    matchPaths: [CONTRACTOR_PORTAL_BASE, `${CONTRACTOR_PORTAL_BASE}/dashboard`],
    enabled: true,
  },
  {
    id: "projects",
    label: "Projects",
    labelFa: "پروژه‌های من",
    path: `${CONTRACTOR_PORTAL_BASE}/projects`,
    enabled: true,
  },
  {
    id: "contracts",
    label: "Contracts",
    labelFa: "قراردادها",
    path: `${CONTRACTOR_PORTAL_BASE}/contracts`,
    enabled: true,
  },
  {
    id: "supervision",
    label: "Supervision",
    labelFa: "نظارت",
    path: `${CONTRACTOR_PORTAL_BASE}/supervision`,
    matchPaths: [
      `${CONTRACTOR_PORTAL_BASE}/supervision`,
      `${CONTRACTOR_PORTAL_BASE}/ProjectAssignments`,
    ],
    enabled: true,
  },
  {
    id: "payments",
    label: "Payments",
    labelFa: "پرداخت‌ها",
    path: `${CONTRACTOR_PORTAL_BASE}/payments`,
    enabled: true,
  },
  {
    id: "profile",
    label: "Profile",
    labelFa: "پروفایل",
    path: `${CONTRACTOR_PORTAL_BASE}/profile`,
    enabled: true,
  },
];

/** Future placeholders — navigation only, no pages yet. */
export const CONTRACTOR_PORTAL_FUTURE_NAV_ITEMS = [
  {
    id: "progress",
    labelFa: "پیشرفت پروژه",
    enabled: false,
  },
  {
    id: "defects",
    labelFa: "ایرادات",
    enabled: false,
  },
  {
    id: "handover",
    labelFa: "تحویل پروژه",
    enabled: false,
  },
];

export const getEnabledContractorPortalNavItems = () =>
  CONTRACTOR_PORTAL_NAV_ITEMS.filter((item) => item.enabled);

export const isContractorPortalNavSelected = (item, pathname) => {
  const path = (pathname || "").toLowerCase().replace(/\/+$/, "") || "/";
  const candidates = (item.matchPaths || [item.path]).map((p) =>
    String(p).toLowerCase().replace(/\/+$/, "")
  );
  if (item.id === "dashboard") {
    return candidates.some((p) => path === p);
  }
  return candidates.some(
    (p) => path === p || path.startsWith(`${p}/`)
  );
};
